import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Grid, Paper } from "@material-ui/core";
import useStyles from "assets/jss/material-dashboard-react/components/customFilterStyle";
import { Formik, Form as FormikForm } from "formik";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import eightAxios from "configs/axiosConfig";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";
import { useTranslation } from "react-i18next";

function AttendanceMethod() {
  const { t } = useTranslation();
  const classes = useStyles();
  const submitUrl = "/attendance-method/";
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(null);
  const setNotify = useNotifyContext();

  const initialValues = {
    attendance_method: current ? current : "",
  };
  const formButtons = [
    {
      type: "submit",
      label: "Save",
      color: "primary",
    },
  ];
  const validationSchema = Yup.object({
    attendance_method: Yup.string().required("Choose one option"),
  });

  const getAttendanceMethod = () => {
    setLoading(true);
    eightAxios
      .get(submitUrl)
      .then((response) => {
        setCurrent(response.data.attendance_method);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getAttendanceMethod();
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    eightAxios
      .post(submitUrl, { attendance_method: current })
      .then(() => {
        setSubmitting(false);
        setNotify({
          isOpen: true,
          message: "Successfully saved!",
          type: "success",
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
      });
  };

  const radioStyle = {
    marginLeft: "1.9%",
    width: "36%",
    marginBottom: "10px",
    marginTop: "4px",
  };

  const handleChange = (event) => {
    let target = event.target;
    let value = target.value;
    setCurrent(value);
  };

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <Grid>
      <Paper
        className={classes.filterPaper}
        variant="outlined"
        style={{ backgroundColor: "#dedede" }}
      >
        {t("Attendance Method")} <br />
      </Paper>
      <Paper className={classes.filterPaper} variant="outlined">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => {
            return (
              <FormikForm>
                <Grid
                  container
                  className={classes.formContainer}
                  direction="row"
                  spacing={2}
                >
                  <Grid item>
                    <label>
                      <input
                        type="radio"
                        name="attendance_method"
                        value="Worker scans QR code"
                        checked={current === "Worker scans QR code"}
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          marginLeft: 3,
                        }}
                      >
                        Option 1: {t("Worker scans QR code")}
                      </span>
                      <div style={radioStyle}>
                        {t(
                          "QR Code to be displayed at the estate office or Supervisor hold the QR Code. The Worker will scan the QR Code from office or Supervisor."
                        )}
                      </div>
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="attendance_method"
                        value="Supervisor scans QR code of the worker"
                        checked={
                          current === "Supervisor scans QR code of the worker"
                        }
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          marginLeft: 3,
                        }}
                      >
                        Option 2: {t("Supervisor scans QR code of the worker")}
                      </span>
                      <div style={radioStyle}>
                        {t(
                          "QR Code to be displayed in Mobile Application of each Worker and Supervisor will scan the QR Code. For Worker without smartphone, individual QR Code needs to be printed, then Supervisor shall scan the QR Code."
                        )}{" "}
                      </div>
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="attendance_method"
                        value="Both worker and supervisor scans QR code"
                        checked={
                          current === "Both worker and supervisor scans QR code"
                        }
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          marginLeft: 3,
                        }}
                      >
                        Option 3: {t("Both")}
                      </span>
                      <div style={radioStyle}>
                        {t(
                          "Applicable to use both Option 1 and Option 2 simultaneously."
                        )}
                      </div>
                    </label>
                  </Grid>
                </Grid>

                <Grid container justify="flex-start" spacing={3}>
                  {formButtons.map((formButton, index) => {
                    return (
                      <Grid key={index} item xs={12} sm={6} md={4} lg={1}>
                        <Button
                          style={{ textTransform: "capitalize" }}
                          type={formButton.type}
                          variant="contained"
                          color={formButton.color}
                          disabled={formik.isSubmitting}
                          startIcon={<SaveIcon />}
                          fullWidth
                        >
                          {t(formButton.label)}
                        </Button>
                      </Grid>
                    );
                  })}
                </Grid>
              </FormikForm>
            );
          }}
        </Formik>
      </Paper>
    </Grid>
  );
}
export default AttendanceMethod;
